const PATHNAME_TO_SOURCE_FROM_MAP = {
	"doubletake": "Doubletake",
	"match": "Discovery",
	"who-likes-you": "Likes",
	"who-you-like": "Likes",
	"messages": "Messages",
	"upgrade": "Alist",
	"bookmarks": "Bookmarks",
	"settings": "Settings",
	"profile": "Profile",
	"flagmod": "Flag mod",
	"home": "Home",
};

export default function sourceFromPathname() {
	const { location: { pathname } } = window;
	const firstPathname = pathname.substr(1).split("/")[0];

	return PATHNAME_TO_SOURCE_FROM_MAP[firstPathname];
}




// WEBPACK FOOTER //
// ./src/analytics/util/source.js